import styled from 'styled-components';

export const StyledAdminFilterSelectContainer = styled.div`
  height: 30rem;
`;
